import React from "react";
import Badge from "./badge";
import * as Icons from "../assets/svgs/icons";
import type { RoundProps } from "./badge/Round";

interface AirTitleProps {
  type?: "main" | "sub";
  badge?: RoundProps[];
  title?: string;
  subtitle?: string;
  mode?: "tutor" | "socrates"; // 튜터 or 소크라테스 모드
}

const AirTitle: React.FC<AirTitleProps> = ({
  type = "main",
  badge,
  title,
  subtitle,
  mode = "socrates", // 기본값은 소크라테스
}) => {
  // MAIN TITLE
  if (type === "main") {
    // 모드에 따라 아이콘 선택
    const IconComponent = mode === "tutor" ? Icons.ChatLine : Icons.AiLineDark;

    return (
      <div
        className="content-stretch flex flex-col gap-4 md:gap-4 items-center md:max-w-[800px] w-fit"
        data-name="device=responsive, type=main"
      >
        <div
          className="content-stretch flex gap-2 md:gap-2 items-center justify-center relative shrink-0 w-full"
          data-name="Container"
        >
          <span className="overflow-clip relative shrink-0 w-6 h-6 md:w-8 md:h-8">
            <IconComponent className="w-full h-full" />
          </span>
          <div className="flex flex-col font-bold justify-center leading-0 not-italic relative shrink-0 text-[#212121] text-lg md:text-2xl tracking-[-0.4px] md:tracking-normal whitespace-nowrap">
            <p className="leading-7 md:leading-9">{title}</p>
          </div>
        </div>
        <pre className="flex flex-col font-normal justify-center leading-5 not-italic relative shrink-0 text-[#888888] text-sm text-center tracking-[-0.28px] whitespace-pre-wrap">
          {subtitle}
        </pre>
      </div>
    );
  }

  // SUB TITLE
  return (
    <div
      className="content-stretch flex flex-col gap-2 md:gap-2 items-start md:max-w-[800px]"
      data-name="device=responsive, type=sub"
    >
      {badge && badge.length > 0 && (
        <div className="content-stretch flex gap-1 md:gap-2 items-center relative shrink-0">
          {badge.map((props, idx) => (
            <Badge.Round key={idx} {...props} />
          ))}
        </div>
      )}
      <div className="content-stretch flex gap-2 md:gap-2 items-center justify-center relative shrink-0">
        <div className="flex flex-col font-bold justify-center leading-0 not-italic relative shrink-0 text-[#212121] text-lg md:text-2xl tracking-[-0.4px] md:tracking-normal whitespace-nowrap">
          <p className="leading-7 md:leading-9">{title}</p>
        </div>
      </div>
    </div>
  );
};

export default AirTitle;
